(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luxury-overrides"] && !Shopify.designMode) return;
  try {
    // Wrap mega menu heading text in spans for precise underline control
  function wrapMegaMenuHeadings() {
    const menuLinks = document.querySelectorAll('.mega-menu__link--level-2');

    menuLinks.forEach((link) => {
      // Get all child nodes
      const childNodes = Array.from(link.childNodes);

      // Find text nodes (the heading text, not ::after)
      childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          // Create span wrapper
          const span = document.createElement('span');
          span.className = 'mega-menu__heading-text';
          span.textContent = node.textContent;

          // Replace text node with span
          link.replaceChild(span, node);
        }
      });
    });
  }

  // Announcement bar - minimal dismiss with per-message persistence
  function initAnnouncementBarDismiss() {
    const bar = document.querySelector('.announcement-bar-section .utility-bar');
    if (!bar) return;

    const messageEl =
      bar.querySelector('.announcement-bar__message span') || bar.querySelector('.announcement-bar__message');
    const text = messageEl && messageEl.textContent ? messageEl.textContent.trim() : '';
    if (!text) return;

    const storageKey = 'deuxAmisAnnouncementDismissed';

    try {
      if (window.localStorage) {
        const stored = localStorage.getItem(storageKey);
        if (stored === text) {
          // User has already dismissed this exact message: keep bar hidden
          return;
        }
      }
    } catch (e) {
      // Ignore storage errors
    }

    // Show bar for first-time or updated message
    bar.classList.add('announcement-bar--active');

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'announcement-bar__close';
    close.setAttribute('aria-label', 'Close announcement');
    close.textContent = '×';
    bar.appendChild(close);

    close.addEventListener('click', () => {
      bar.classList.remove('announcement-bar--active');
      bar.classList.add('announcement-bar--hidden');
      try {
        if (window.localStorage) {
          localStorage.setItem(storageKey, text);
        }
      } catch (e) {
        // Ignore storage errors
      }
    });
  }

  // Mega Menu - Hover behavior with seamless transitions
  class MegaMenuController {
    constructor() {
      this.init();
    }

    init() {
      if (window.innerWidth < 990) return;

      this.headerMenus = document.querySelectorAll('header-menu');
      if (this.headerMenus.length === 0) return;

      this.currentOpenMenu = null;
      this.closeTimeout = null;

      this.#attachEventListeners();
    }

    #attachEventListeners() {
      for (const menu of this.headerMenus) {
        const details = menu.querySelector('details');
        const summary = menu.querySelector('summary');
        const content = menu.querySelector('.mega-menu__content');

        if (!details || !summary || !content) continue;

        // Open on hover
        summary.addEventListener('mouseenter', () => this.#openMenu(details));

        // Keep open when hovering over content
        content.addEventListener('mouseenter', () => this.#cancelClose());

        // Start close timer when leaving menu area
        menu.addEventListener('mouseleave', () => this.#scheduleClose());

        // Prevent default click behavior
        summary.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.#closeAllMenus();
        }
      });

      // Close when clicking outside
      document.addEventListener('click', (e) => {
        const clickedInsideMenu = e.target.closest('header-menu');
        if (!clickedInsideMenu) {
          this.#closeAllMenus();
        }
      });
    }

    #openMenu(details) {
      this.#cancelClose();

      // Close other menus instantly if switching between them
      for (const menu of this.headerMenus) {
        const otherDetails = menu.querySelector('details');
        if (otherDetails && otherDetails !== details && otherDetails.open) {
          otherDetails.open = false;
        }
      }

      // Open the target menu
      if (!details.open) {
        details.open = true;
      }

      this.currentOpenMenu = details;
    }

    #scheduleClose() {
      this.#cancelClose();

      this.closeTimeout = setTimeout(() => {
        this.#closeAllMenus();
      }, 200);
    }

    #cancelClose() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
    }

    #closeAllMenus() {
      for (const menu of this.headerMenus) {
        const details = menu.querySelector('details');
        if (details) {
          details.open = false;
        }
      }
      this.currentOpenMenu = null;
    }
  }

  // Mobile Menu - Instant state management for buttery smooth transitions
  class MobileMenuController {
    constructor() {
      this.init();
    }

    init() {
      if (window.innerWidth >= 990) return;

      this.menuDrawerContainer = document.querySelector('.menu-drawer-container');
      if (!this.menuDrawerContainer) return;

      this.menuButton = this.menuDrawerContainer.querySelector('summary');
      this.menuDrawer = document.querySelector('.menu-drawer');

      if (!this.menuButton || !this.menuDrawer) return;

      this.#attachEventListeners();
      this.#preventDefaultBehavior();
    }

    #attachEventListeners() {
      // Handle main menu open/close
      this.menuButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.#toggleMainMenu();
      });

      // Handle submenu navigation — toggle open/close
      const submenuButtons = this.menuDrawer.querySelectorAll(
        '.menu-drawer__menu.has-submenu > li > details > summary'
      );
      for (const button of submenuButtons) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const details = button.closest('details');
          if (details.open) {
            this.#closeSubmenu(details.querySelector('.menu-drawer__submenu'));
          } else {
            this.#openSubmenu(details);
          }
        });
      }

      // Handle back buttons
      const backButtons = this.menuDrawer.querySelectorAll('.menu-drawer__close-button');
      for (const button of backButtons) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.#closeSubmenu(button.closest('.menu-drawer__submenu'));
        });
      }

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.menuDrawerContainer.open) {
          this.#closeMainMenu();
        }
      });
    }

    #preventDefaultBehavior() {
      // Prevent Dawn's default details behavior
      this.menuDrawerContainer.addEventListener('toggle', (e) => {
        if (!this.isManualToggle) {
          e.preventDefault();
        }
      });
    }

    #toggleMainMenu() {
      if (this.menuDrawerContainer.open) {
        this.#closeMainMenu();
      } else {
        this.#openMainMenu();
      }
    }

    #openMainMenu() {
      this.isManualToggle = true;
      this.menuDrawerContainer.open = true;
      this.menuDrawer.classList.add('menu-opening');

      // Instant appearance
      requestAnimationFrame(() => {
        this.menuDrawer.style.opacity = '1';
        this.menuDrawer.style.visibility = 'visible';
      });

      this.isManualToggle = false;
    }

    #closeMainMenu() {
      this.isManualToggle = true;

      // Instant disappearance
      this.menuDrawer.style.opacity = '0';
      this.menuDrawer.style.visibility = 'hidden';

      // Close after opacity transition
      setTimeout(() => {
        this.menuDrawerContainer.open = false;
        this.menuDrawer.classList.remove('menu-opening');

        // Close any open submenus
        const openSubmenus = this.menuDrawer.querySelectorAll('details[open]');
        for (const submenu of openSubmenus) {
          submenu.open = false;
        }
      }, 0);

      this.isManualToggle = false;
    }

    #openSubmenu(details) {
      details.open = true;
    }

    #closeSubmenu(submenu) {
      const details = submenu.closest('details');
      if (details) {
        details.open = false;
      }
    }
  }

  // Shop Dropdown - Hover-to-open with delays (desktop, pointer-capable only)
  class DropdownHoverController {
    #openDelay = 80;
    #closeDelay = 150;
    #breakpoint = 990;

    constructor() {
      this.#init();
    }

    #init() {
      // Touch-only devices use native tap-to-toggle; skip hover behavior
      if (!window.matchMedia('(hover: hover)').matches) return;

      const menus = document.querySelectorAll('.header__inline-menu header-menu');
      for (const menu of menus) {
        this.#bind(menu);
      }
    }

    #bind(menu) {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;

      let openTimer = null;
      let closeTimer = null;

      const cancelTimers = () => {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      menu.addEventListener('mouseenter', () => {
        if (window.innerWidth < this.#breakpoint) return;
        cancelTimers();
        openTimer = setTimeout(() => {
          // Close any sibling dropdowns before opening this one
          const openSiblings = document.querySelectorAll(
            '.header__inline-menu header-menu details[open]'
          );
          for (const other of openSiblings) {
            if (other !== details) other.open = false;
          }
          details.open = true;
        }, this.#openDelay);
      });

      menu.addEventListener('mouseleave', () => {
        if (window.innerWidth < this.#breakpoint) return;
        cancelTimers();
        closeTimer = setTimeout(() => {
          details.open = false;
        }, this.#closeDelay);
      });
    }
  }

  // Cart Shipping Notice - Inject into cart drawer and cart page
  // Toggle: set to true to enable, false to disable
  const CART_NOTICE_ENABLED = false;
  const CART_NOTICE_TEXT = 'All orders ship December 1';

  function initCartShippingNotice() {
    if (!CART_NOTICE_ENABLED) return;

    const noticeText = CART_NOTICE_TEXT;
    const noticeClass = 'cart-shipping-notice';

    // Inject into cart drawer (above checkout button)
    const drawerCtas = document.querySelector('.cart-drawer .cart__ctas');
    if (drawerCtas && !drawerCtas.previousElementSibling?.classList.contains(noticeClass)) {
      const notice = document.createElement('p');
      notice.className = noticeClass;
      notice.textContent = noticeText;
      drawerCtas.parentNode.insertBefore(notice, drawerCtas);
    }

    // Inject into main cart page (above checkout button)
    const cartCtas = document.querySelector('.cart__footer .cart__ctas');
    if (cartCtas && !cartCtas.previousElementSibling?.classList.contains(noticeClass)) {
      const notice = document.createElement('p');
      notice.className = noticeClass;
      notice.textContent = noticeText;
      cartCtas.parentNode.insertBefore(notice, cartCtas);
    }
  }

  // Re-inject notice after cart updates (AJAX)
  function observeCartUpdates() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
      initCartShippingNotice();
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Initialize controllers on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      wrapMegaMenuHeadings();
      new MegaMenuController();
      new MobileMenuController();
      new DropdownHoverController();
      initAnnouncementBarDismiss();
      initCartShippingNotice();
      observeCartUpdates();
    });
  } else {
    wrapMegaMenuHeadings();
    new MegaMenuController();
    new MobileMenuController();
    new DropdownHoverController();
    initAnnouncementBarDismiss();
    initCartShippingNotice();
    observeCartUpdates();
  }

  // Reinitialize on window resize if crossing breakpoint
  let previousWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    const crossedBreakpoint =
      (previousWidth < 990 && currentWidth >= 990) || (previousWidth >= 990 && currentWidth < 990);

    if (crossedBreakpoint) {
      wrapMegaMenuHeadings();
      new MegaMenuController();
      new MobileMenuController();
    }

    previousWidth = currentWidth;
  });
  } catch(e) { console.error(e); }
})();

})();
